import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <>
      <Navbar />
      <main className="pt-24 md:pt-28">
        <div className="mx-auto max-w-3xl px-4 md:px-6 py-16 md:py-24 text-center">
          <p className="font-heading font-bold text-foreground-950 text-7xl md:text-8xl mb-4">404</p>
          <h1 className="font-heading font-bold text-foreground-950 text-2xl md:text-3xl mb-3">
            {t('notFound.title')}
          </h1>
          <p className="text-foreground-600 text-sm md:text-base mb-8">{t('notFound.desc')}</p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <span className="flex items-center justify-center w-4 h-4">
              <i className="ri-home-5-line text-base" />
            </span>
            {t('article.backHome')}
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
}